<!-- src/js/widgets/lk-manager-notifications/ReplyForm.vue -->
<template>
  <div class="reply-form">
    <div class="field">
      <label for="reply-message">Сообщение *</label>
      <Textarea
        id="reply-message"
        v-model="message"
        rows="5"
        :autoResize="true"
        placeholder="Введите ваш ответ..."
        style="width: 100%"
      />
    </div>

    <div class="field">
      <label>Прикрепить файлы</label>
      <FileUpload
        name="replyAttachments[]"
        :multiple="true"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
        :maxFileSize="20971520"
        :customUpload="true"
        :auto="false"
        :showFileList="false"
        :previewWidth="0"
        chooseLabel="Выбрать файлы"
        uploadLabel="Загрузить"
        cancelLabel="Отмена"
        @select="onFileSelect"
        @remove="onFileRemove"
        :files="attachedFiles"
      />

      <div v-if="attachedFiles.length > 0" class="file-list">
        <div v-for="(file, index) in attachedFiles" :key="index" class="file-item">
          <span>{{ file.name }}</span>
          <Button icon="pi pi-times" severity="danger" text rounded @click="removeFile(index)" />
        </div>
      </div>
    </div>

    <div class="form-actions">
      <Button
        label="Отправить"
        icon="pi pi-send"
        :disabled="!message.trim()"
        @click="submitReply"
      />
      <Button label="Отмена" severity="secondary" @click="$emit('cancel')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import FileUpload from 'primevue/fileupload';

const props = defineProps<{
  parentId: number;
  subject: string;
}>();

const emit = defineEmits<{
  (e: 'submit', message: string): void;
  (e: 'cancel'): void;
}>();

const message = ref('');
const attachedFiles = ref<File[]>([]);

function onFileSelect(event: any) {
  const files = event.files;
  if (files && Array.isArray(files)) {
    const validFiles = files.filter((file): file is File => file instanceof File);
    attachedFiles.value.push(...validFiles);
  }
}

function onFileRemove(event: any) {
  const removedFile = event.file;
  attachedFiles.value = attachedFiles.value.filter(
    (f) => f.name !== removedFile.name || f.size !== removedFile.size,
  );
}

function removeFile(index: number) {
  attachedFiles.value.splice(index, 1);
}

function submitReply() {
  if (message.value.trim()) {
    emit('submit', message.value.trim());
    message.value = '';
    attachedFiles.value = [];
  }
}
</script>
